import NewMoneyIcon from 'assets/svg/New_moneyIcon'
import { THeaderType } from 'components/Header/Header'
import LinkWithLocale from 'components/LinkWithLocale'
import React from 'react'
import styled from 'styled-components'

const RefferalItem = (props: { withLocale: boolean; href: string; type: THeaderType }) => {
  const { href = '', type, withLocale } = props

  return (
    <RefferalLink withLocale={withLocale} to={href} $type={type}>
      <Name>Referral</Name>
      <IconContainer>
        <NewMoneyIcon green />
      </IconContainer>
    </RefferalLink>
  )
}

export default RefferalItem

const RefferalLink = styled(LinkWithLocale)<{ $type: THeaderType }>`
  display: flex;
  align-items: center;
  color: ${({ $type, theme: { colors } }) =>
    $type === 'primary' ? colors.newDarkColor.softNavy : colors.newLightColor.white};
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;

  :hover {
    color: ${({ $type, theme: { colors } }) =>
      $type === 'primary' ? colors.newLightColor.vividBlue : colors.newDarkColor.cyanBlue};
  }
`

const Name = styled.span`
  margin-inline-end: 9px;

  @media ${props => props.theme.device.xxm} and (max-width: 1399px) {
    font-size: 13px;
    margin-inline-end: 3px;
  }
`
const IconContainer = styled.div`
  width: 24px;
  height: 24px;
`
